const locale ={
    HELP :"Aide",
    PRIVACY:"Vie privée",
    TERMS:"Petits caractères",
}

export default locale